import { createClient } from '@supabase/supabase-js';

// Use .trim() to prevent any accidental whitespace issues from .env
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL?.trim();
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

const isPlaceholder = !SUPABASE_URL || SUPABASE_URL.includes('placeholder') || !SUPABASE_ANON_KEY;

const supabase = createClient(
  isPlaceholder ? 'https://placeholder.supabase.co' : SUPABASE_URL,
  isPlaceholder ? 'placeholder-key' : SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    }
  }
);

export default supabase;